/**
 * Static numerology texts in both languages. Embedded as TS const objects
 * (not imported from JSON) so the shared package doesn't need to ship JSON
 * assets alongside its compiled dist. Source of truth for editing is the
 * sibling .json files in ./texts/ — re-copy here after editing those.
 */
import destinyRuRaw from './texts/destiny.ru.json';
import destinyEnRaw from './texts/destiny.en.json';
import expressionRuRaw from './texts/expression.ru.json';
import expressionEnRaw from './texts/expression.en.json';
import dailyRuRaw from './texts/daily.ru.json';
import dailyEnRaw from './texts/daily.en.json';
import compatRuRaw from './texts/compat.ru.json';
import compatEnRaw from './texts/compat.en.json';
export const DESTINY_TEXTS = {
    ru: destinyRuRaw,
    en: destinyEnRaw,
};
export const EXPRESSION_TEXTS = {
    ru: expressionRuRaw,
    en: expressionEnRaw,
};
export const DAILY_TEXTS = {
    ru: dailyRuRaw,
    en: dailyEnRaw,
};
export const COMPAT_TEXTS = {
    ru: compatRuRaw,
    en: compatEnRaw,
};
export function getDestinyText(num, lang) {
    return DESTINY_TEXTS[lang][String(num)] ?? '';
}
export function getExpressionText(num, lang) {
    return EXPRESSION_TEXTS[lang][String(num)] ?? '';
}
export function getDailyText(num, lang) {
    return DAILY_TEXTS[lang][String(num)] ?? '';
}
export function getCompatEntry(key, lang) {
    return COMPAT_TEXTS[lang][key] ?? null;
}
//# sourceMappingURL=texts.js.map